import { BlogSection } from '@/types/blog';

export const wer_war_kostolany: BlogSection = {
  id: 'wer-war-kostolany',
  title: 'André Kostolany: Ein Leben im Zeichen der Börse',
  content: `
    <p>André Kostolany, 1906 in Budapest geboren, war eine wahre Legende der Finanzwelt. Seine über 70-jährige <strong>Börsenkarriere</strong> begann in den 1920er Jahren an der Pariser Börse, nachdem sein Vater ihn zwang, sein Philosophie- und Kunstgeschichtsstudium aufzugeben. Diese unkonventionelle Ausbildung sollte jedoch die Grundlage für seine einzigartige Sicht auf die Finanzmärkte bilden.</p>

    <div class="grid md:grid-cols-2 gap-6 my-8">
      <div class="bg-joerg-50 p-6 rounded-lg">
        <h4 class="font-semibold text-joerg-800 mb-3">🎓 Unkonventioneller Werdegang</h4>
        <ul class="space-y-2 text-joerg-700">
          <li>• Studium der Philosophie und Kunstgeschichte</li>
          <li>• Ursprünglich wollte er Pianist werden</li>
          <li>• Zwangsweise Börsenkarriere durch den Vater</li>
          <li>• Diese Vielseitigkeit prägte seinen ganzheitlichen Ansatz</li>
        </ul>
      </div>
      <div class="bg-primary/5 p-6 rounded-lg">
        <h4 class="font-semibold text-joerg-800 mb-3">📈 Börsenlegende</h4>
        <ul class="space-y-2 text-joerg-700">
          <li>• 70+ Jahre aktive Börsentätigkeit</li>
          <li>• Arbeit an allen großen Börsen der Welt</li>
          <li>• Erfolgreiche Warnung vor dem Neuen Markt-Crash</li>
          <li>• Bestseller-Autor und gefragter Experte</li>
        </ul>
      </div>
    </div>

    <p>Er war kein reiner Zahlenguru, sondern ein <strong>Analytiker der menschlichen Seele</strong> und der gesellschaftlichen Stimmungen. Seinen Ruf als angesehener Börsenexperte und „Altmeister" erlangte er nicht nur durch seine Erfolge, sondern vor allem durch seine Bestseller und seine Fähigkeit, komplexe finanzielle Zusammenhänge in einfache, oft humorvolle Anekdoten und markante Sprüche zu verpacken.</p>

    <p>Bis zu seinem Tod im Jahr 1999 im Alter von 93 Jahren blieb er der Börse leidenschaftlich verbunden. Seine Weitsicht wurde insbesondere kurz vor seinem Tod deutlich, als er vor dem drohenden Crash am Neuen Markt warnte und damit Recht behielt. Seine Lehren gelten als zeitlos, da sie auf unveränderlichen menschlichen Verhaltensweisen basieren.</p>

    <blockquote class="border-l-4 border-primary pl-6 italic text-lg text-joerg-700 my-6">
      "Die Börse ist nicht logisch, sie ist psychologisch."
      <footer class="text-sm text-joerg-600 mt-2">— André Kostolany</footer>
    </blockquote>
  `
};